import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAuth } from '../providers/AuthProvider';

/**
 * OAuthCallbackPage — receives `?token=` from the OAuth redirect,
 * stores it in auth context, and navigates the user to /agents.
 * If no token is present, redirects to /login with an error.
 */
export function OAuthCallbackPage(): React.JSX.Element {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const token = searchParams.get('token');

    if (token) {
      login(token);
      navigate('/agents', { replace: true });
    } else {
      navigate('/login?error=oauth_failed', { replace: true });
    }
  }, [searchParams, login, navigate]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-border border-t-byron" />
        <p className="text-sm text-text-muted">Completing sign-in…</p>
      </div>
    </div>
  );
}
